import React from "react"
import TopMenu from "../components/nav"
import CookieBanner from "../components/CookieBanner"

function NavFooterLayout({ children }) {
  return (
    <div className="page-wrapper">
      <TopMenu />
      {children}
      <CookieBanner />
    </div>
  )
}

export default NavFooterLayout
